import {Typography} from '@mui/material';
import React from 'react';

import {Row, StyledCard} from 'presentation/components';
import {useRefundRequest} from 'presentation/pages/private/refund/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';

const {title, patient, providerDocument, providerName, specialty} =
	translations['pt-br'].privateFlow.refund.conferencePage.providerAndPatient;

export const ProviderAndPatient = () => {
	const {requests} = useRefundRequest();
	const firstRequestData = requests.requestData?.[0];

	return (
		<StyledCard.Container>
			<Typography fontWeight={600} variant="subtitle2" color={'text.secondary'}>
				{title}
			</Typography>

			<Row.Compound
				items={[
					{
						title: patient,
						value: firstRequestData?.beneficiaryName ?? '',
					},
				]}
			/>
			<Row.Compound
				items={[
					{
						title: providerDocument,
						value: firstRequestData?.professionalData.professionalDocument ?? '',
					},
				]}
			/>
			<Row.Compound
				items={[
					{
						title: providerName,
						value: firstRequestData?.professionalData.professionalName ?? '',
					},
				]}
			/>
			<Row.Compound
				items={[
					{
						title: specialty,
						value: formatText(
							firstRequestData?.treatmentData.specialty.description ?? '',
						),
					},
				]}
				hiddenDivider
			/>
		</StyledCard.Container>
	);
};
